import { Alert } from '@numistic/ui'

import { useErrorText } from '../lib/errors.js'

/**
 * Ошибка действия (удалить, переместить, массовая правка…), у которого нет своей формы:
 * без неё неудачный запрос выглядел бы как «ничего не произошло».
 */
export function MutationErrors({ errors }: { errors: unknown[] }) {
  const errorText = useErrorText()
  const error = errors.find(Boolean)
  if (!error) return null
  return <Alert variant="destructive">{errorText.request(error)}</Alert>
}
